module.exports = __webpack_public_path__ + "img/pole-red.521f3287.webp";